import React from 'react';
import { FieldTextInput, FieldSelect } from '../../../components';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { required } from '../../../util/validators';
import css from './SignupForm.module.css';
import { US_STATES } from '../../../util/enums';

const AddressFormField = () => {
  const intl = useIntl();

  return (
    <div className={css.newLocationForm}>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id="addressLine2"
          name="addressLine2"
          label={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.streetAddressLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'SignupForm.FanAddressFormFields.streetAddressPlaceholder',
          })}
        />
      </div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id="city"
          name="city"
          placeholder="City"
          label={intl.formatMessage({
            id: 'AddressFormField.cityLabel',
          })}
        />
      </div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldSelect
          className={css.formFld}
          id="state"
          name="state"
          label={intl.formatMessage({ id: 'AddressFormField.stateLabel' })}
          validate={required(intl.formatMessage({ id: 'AddressFormField.stateRequired' }))}
        >
          <option disabled value="">
            {intl.formatMessage({ id: 'AddressFormField.statePlaceholder' })}
          </option>
          {US_STATES.map(s => (
            <option key={s.code} value={s.code}>
              {s.name}
            </option>
          ))}
        </FieldSelect>
      </div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id="zipCode"
          name="zipCode"
          placeholder="Zip code"
          label={intl.formatMessage({
            id: 'AddressFormField.zipCodeLabel',
          })}
        />
      </div>
    </div>
  );
};

export default AddressFormField;
